import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { Clear } from "@mui/icons-material";

const PATClearButton = ({ title, onClick, color = "primary" }) => {
  return (
    <Tooltip title={title}>
      <IconButton onClick={onClick} color={color}>
        <Clear />
      </IconButton>
    </Tooltip>
  );
};

export default PATClearButton;
